export const employees = [
    {
        name: "Ashley Palma",
        initials: "AP",
        role: "Senior Developer",
        employee_id: "EMP001",
        details: {
            department: "Engineering",
            productivity_score: 88,
            status: "5% increase",
            metrics: {
                weekly_average: 8.1,
                monthly_total: 162,
                efficiency: 92,
                tasks_done: 47,
            },
            daily_breakdown: [
                { date: "Oct 6", total: 8.5, productive: 7.2, meetings: 1.5, breaks: 0.5 },
                { date: "Oct 7", total: 7.8, productive: 6.5, meetings: 2.0, breaks: 0.3 },
                { date: "Oct 8", total: 8.2, productive: 7.5, meetings: 1.2, breaks: 0.5 },
                { date: "Oct 9", total: 8.0, productive: 6.8, meetings: 1.8, breaks: 0.4 },
                { date: "Oct 10", total: 8.5, productive: 7.8, meetings: 1.0, breaks: 0.7 },
                { date: "Oct 11", total: 8.3, productive: 7.3, meetings: 1.5, breaks: 0.5 },
                { date: "Oct 12", total: 7.5, productive: 6.2, meetings: 2.2, breaks: 0.3 }
            ],
            message: "Ashley is performing exceptionally well with 88% productivity score. Consider recognizing this achievement!",
            
        }
    },
    {
        name: "Michael Roberts",
        initials: "MR",
        role: "Project Manager",
        employee_id: "EMP005",
        details: {
            department: "Operations",
            productivity_score: 78,
            status: "5% increase",
            metrics: {
                weekly_average: 8.1,
                monthly_total: 160,
                efficiency: 80,
                tasks_done: 35,
            },
            daily_breakdown: [
                { date: "Oct 6", total: 8, productive: 6, meetings: 3.5, breaks: 0.5 },
                { date: "Oct 7", total: 8.5, productive: 6.5, meetings: 3.2, breaks: 0.8 },
                { date: "Oct 8", total: 8.2, productive: 6.2, meetings: 3, breaks: 0.5 },
                { date: "Oct 9", total: 7.8, productive: 5.8, meetings: 3.5, breaks: 0.5 },
                { date: "Oct 10", total: 8.5, productive: 6.5, meetings: 3, breaks: 0.5 },
                { date: "Oct 11", total: 8, productive: 6, meetings: 3.5, breaks: 0.5 },
                { date: "Oct 12", total: 7.5, productive: 5.5, meetings: 3.8, breaks: 0.5 }
            ],
            message: "Michael is maintaining good productivity at 78%. Consider opportunities for further optimization.",
        }
    },
    {
        name: "Saccharine Elupre",
        initials: "SE",
        role: "Marketing Manager",
        employee_id: "EMP002",
        details: {
            department: "Marketing",
            productivity_score: 85,
            status: "3% increase",
            metrics: {
                weekly_average: 8.2,
                monthly_total: 165,
                efficiency: 89,
                tasks_done: 52,
            },
            daily_breakdown: [
                { date: "Oct 6", total: 8.0, productive: 6.8, meetings: 1.0, breaks: 0.5 },
                { date: "Oct 7", total: 8.5, productive: 7.5, meetings: 0.8, breaks: 0.7 },
                { date: "Oct 8", total: 8.2, productive: 7.0, meetings: 1.2, breaks: 0.5 },
                { date: "Oct 9", total: 7.5, productive: 6.0, meetings: 1.5, breaks: 0.5 },
                { date: "Oct 10", total: 8.8, productive: 8.0, meetings: 0.5, breaks: 0.8 },
                { date: "Oct 11", total: 8.3, productive: 7.3, meetings: 1.0, breaks: 0.5 },
                { date: "Oct 12", total: 8.0, productive: 6.8, meetings: 1.2, breaks: 0.5 }
            ],
            message: "Saccharine is performing well with 85% productivity score. Consider recognizing this achievement!",
        }
    },
    {
        name: "James Anderson",
        initials: "JA",
        role: "Customer Success Manager",
        employee_id: "EMP003",
        details: {
            department: "Customer Success",
            productivity_score: 82,
            status: "2% decrease",
            metrics: {
                weekly_average: 8.1,
                monthly_total: 161,
                efficiency: 85,
                tasks_done: 38,
            },
            daily_breakdown: [
                { date: "Oct 6", total: 8.5, productive: 7, meetings: 2.5, breaks: 0.5 },
                { date: "Oct 7", total: 8, productive: 6.5, meetings: 2.8, breaks: 0.5 },
                { date: "Oct 8", total: 7.8, productive: 6.2, meetings: 2.5, breaks: 0.3 },
                { date: "Oct 9", total: 8.2, productive: 6.8, meetings: 2.2, breaks: 0.5 },
                { date: "Oct 10", total: 8.5, productive: 7.2, meetings: 2, breaks: 0.8 },
                { date: "Oct 11", total: 8, productive: 6.5, meetings: 2.5, breaks: 0.5 },
                { date: "Oct 12", total: 7.5, productive: 6, meetings: 2.8, breaks: 0.5 }
            ],
            message: "James is maintaining good productivity at 82%. Consider opportunities for further optimization.",
        }
    },
    {
        name: "Emma Wilson",
        initials: "EW",
        role: "UX Designer",
        employee_id: "EMP004",
        details: {
            department: "Design",
            productivity_score: 91,
            status: "7% increase",
            metrics: {
                weekly_average: 8.3,
                monthly_total: 168,
                efficiency: 94,
                tasks_done: 44,
            },
            daily_breakdown: [
                { date: "Oct 6", total: 8.2, productive: 7.5, meetings: 1, breaks: 0.5 },
                { date: "Oct 7", total: 8.5, productive: 7.8, meetings: 0.8, breaks: 0.7 },
                { date: "Oct 8", total: 8.8, productive: 8, meetings: 1.2, breaks: 0.6 },
                { date: "Oct 9", total: 8, productive: 7, meetings: 1.5, breaks: 0.5 },
                { date: "Oct 10", total: 8.5, productive: 7.8, meetings: 1, breaks: 0.7 },
                { date: "Oct 11", total: 8.3, productive: 7.5, meetings: 1.2, breaks: 0.6 },
                { date: "Oct 12", total: 8, productive: 7.2, meetings: 1.5, breaks: 0.5 },
            ],
            message: "Emma currently has a productivity score of 91%. Excellent performance with a notable increase in efficiency and tasks completed.",
        }   
    }

];